import { Stack } from '@chakra-ui/react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Button, Text, VStack } from 'components/uikit';
import { setPaymentStatusAtom } from 'data/payments/atoms';
import { isFormLoading } from 'utils/atoms/dataFetchingAtom';

interface PaymentStatusControlsProps {
  id: string;
}

export function PaymentStatusControls({ id }: PaymentStatusControlsProps) {
  const { t } = useTranslation('payments');

  const [formState, setStatus] = useAtom(setPaymentStatusAtom);

  const isLoading = isFormLoading(formState);

  return (
    <VStack spacing='8px'>
      <Text
        as='h1'
        fontSize='md'
        fontWeight='semibold'
        color='grey.tertiaryText'
        textAlign='center'
      >
        {t('payment_finalize')}
      </Text>
      <Stack direction='row' flexWrap='wrap'>
        <Button
          isLoading={isLoading}
          variant='success'
          onClick={() => {
            setStatus({ depositId: id, status: 'PAID' });
          }}
        >
          {t('payment_complete')}
        </Button>
        <Button
          isLoading={isLoading}
          variant='error'
          onClick={() => {
            setStatus({ depositId: id, status: 'EXPIRED' });
          }}
        >
          {t('payment_expired')}
        </Button>
        <Button
          isLoading={isLoading}
          variant='grey'
          onClick={() => {
            setStatus({ depositId: id, status: 'CANCELLED' });
          }}
        >
          {t('payment_cancelled')}
        </Button>
      </Stack>
    </VStack>
  );
}
